import { LoginForm } from './LoginForm';
import { OTPForm } from './OTPForm';
import { TwoFactorSelector } from './TwoFactorSelector';
import { useAuthStatus } from './hooks/useAuthStatus';

type FormProps = {
  setNotValidatedEmail: (email: string) => void;
};

export const Form = ({ setNotValidatedEmail }: FormProps) => {
  const { authStep } = useAuthStatus();

  switch (authStep) {
    case `login`:
      return <LoginForm setNotValidatedEmail={setNotValidatedEmail} />;
    case `methodSelector`:
      return <TwoFactorSelector />;
    case `email`:
    case `sms`:
      return <OTPForm twoFactorMethod={authStep} />;
    default:
      return null;
  }
};
